<template lang="pug">
    .settings-page.settings-listing
        settings-page-head
        .settings-page__body(v-if="loaded")
            .settings-section-head Game Settings
            .settings-list
                .settings-list__item(v-for="(game, gameIndex) in fields.games")
                    .settings-list__remove
                        re-button.btn-primary.btn-circle(@click="removeGame(gameIndex)")
                            svg-icon(iconId="trash-can")
                    .row
                        .col-sm-6(:style="{ height: '167.5px' }")
                            re-select(label="Game" :options="gameTitles" blankOption="Select game..."
                                v-model.trim="$v.fields.games.$model[gameIndex].name"
                                :validations="validations.games.$each.name" :v="$v.fields.games.$each[gameIndex].name" @input="$v.fields.games.$each[gameIndex].name.$reset"
                            )
                            re-select2(label="Add-Ons" :options="gameAddons(game.name)" :settings="{ multiple: true }" placeholder="Select add-ons..."
                                v-model.trim="fields.games[gameIndex].addons"
                            )
                        .col-sm-6
                            re-textarea.re-textarea--two-lines(label="Description" v-model.trim="$v.fields.games.$model[gameIndex].description" :validations="validations.games.$each.description" :v="$v.fields.games.$each[gameIndex].description" @input="$v.fields.games.$each[gameIndex].description.$reset")
                re-button.btn-outline-primary.btn-lg.settings-list__add(@click="addGame") Add Game

            .settings-section-head Restrictions
            
            .row
                .col-sm-6
                    re-input(label="Reservation Minimum Hours in Advance" type="number" :min="minHoursInAdvance" step="1" v-model.trim="$v.fields.hours_in_advance.$model" :validations="validations.hours_in_advance" :v="$v.fields.hours_in_advance" @input="$v.fields.hours_in_advance.$reset")
                .col-sm-6
                    re-input(label="Reservation Maximum Days in Future" type="number" min="1" max="365" step="1" v-model.trim="$v.fields.days_in_future.$model" :validations="validations.days_in_future" :v="$v.fields.days_in_future" @input="$v.fields.days_in_future.$reset")
                .col-sm-6
                    re-input(label="Maximum Number of Hours" type="number" min="2" step="1" v-model.trim="$v.fields.max_slots.$model" :validations="validations.max_slots" :v="$v.fields.max_slots" @input="$v.fields.max_slots.$reset")

            .settings-section-head Location Settings
            .row
                .col-sm-6
                    re-input(label="Street" v-model.trim="$v.fields.street.$model" :validations="validations.street" :v="$v.fields.street" @input="$v.fields.street.$reset")
                .col-sm-6
                    re-input(label="State" v-model.trim="$v.fields.state.$model" :validations="validations.state" :v="$v.fields.state" @input="$v.fields.state.$reset")
            .row
                .col-sm-6
                    re-select(label="Country" v-model.trim="$v.fields.country.$model" :validations="validations.country" :v="$v.fields.country" @input="$v.fields.country.$reset")
                        option(value="" disabled hidden)
                        option(v-for="country in countries" :value="country.code") {{ country.name }}
                .col-sm-6
                    re-input(label="City" v-model.trim="$v.fields.city.$model" :validations="validations.city" :v="$v.fields.city" @input="$v.fields.city.$reset")
            .row
                .col-sm-6
                    re-input(label="Zip Code" v-model.trim="$v.fields.zip.$model" :validations="validations.zip" :v="$v.fields.zip" @input="$v.fields.zip.$reset")
                .col-sm-6
                    re-input(label="Mile Radius" v-model.trim="$v.fields.radius.$model" :validations="validations.radius" :v="$v.fields.radius" @input="$v.fields.radius.$reset")

            .settings-section-head Available Hours
            table.table.table-borderless.table-striped.settings-table.settings-open-hours-table
                thead
                    th Weekday
                    th Open
                    th Close
                    th Break
                tbody
                    template(v-for="weekday in Array(7).keys()")
                        tr(:key="weekday")
                            td.text-center {{ weekdays[weekday] }}
                            td
                                re-input.re-input--center(type="time" v-model.trim="$v.fields.openHours.$model[weekday][0]" :validations="validations.openHours.$each[0]" :v="$v.fields.openHours.$each[weekday][0]" @input="$v.fields.openHours.$each[weekday][0].$reset")
                            td
                                re-input.re-input--center(type="time" v-model.trim="$v.fields.openHours.$model[weekday][1]" :validations="validations.openHours.$each[1]" :v="$v.fields.openHours.$each[weekday][1]" @input="$v.fields.openHours.$each[weekday][1].$reset")
                            td
                                .settings-open-hours-table__break
                                    a.re-button(@click="addBreak(weekday)")
                                        svg-icon(iconId="break-add")
                        tr(v-for="(breakTime, breakIndex) in $v.fields.breaks.$model[weekday]" :key="`${weekday}:${breakIndex}`")
                            td
                            td
                                re-input.re-input--center(type="time" v-model.trim="breakTime[0]" :validations="validations.breaks.$each.$each[0]" :v="$v.fields.breaks.$each[weekday].$each[breakIndex][0]" @input="$v.fields.breaks.$each[weekday].$each[breakIndex][0].$reset")
                            td
                                re-input.re-input--center(type="time" v-model.trim="breakTime[1]" :validations="validations.breaks.$each.$each[1]" :v="$v.fields.breaks.$each[weekday].$each[breakIndex][1]" @input="$v.fields.breaks.$each[weekday].$each[breakIndex][1].$reset")
                            td
                                .input-group
                                    a.re-button.mr-1(@click="addBreak(weekday, breakIndex + 1)")
                                        svg-icon(iconId="break-add")
                                    a.re-button(@click="removeBreak(weekday, breakIndex)")
                                        svg-icon(iconId="break-remove")

            .settings-section-head Fee Settings
            re-checkbox(v-model="fields.includeMileageFee" label="Include Mileage Fee")

            re-toast-alert.mt-5(v-if="formErrorMessage" type="danger") {{ formErrorMessage }}

            .settings-save-button
                re-button.btn-primary.btn-lg(@click="submit" :loading="submitting") Save

</template>

<script>
import ComponentMixin from 'utils/vue/mixins/components/complex'
import FormMixin from 'utils/vue/mixins/form'
import { Validators, parseValidations, setValidationRule, parseValidationSetup, zipRuleIfNotEmpty } from 'utils/vue/lib/validations'
import { countries, get$ } from 'utils/vue/lib/utils'
import { getFirstErrorMessage } from 'utils/vue/services/main'

const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

const minHoursInAdvance = window.addiesaas.lairdnd.gamemaster.min_hours_in_advance

const VALIDATIONS = {
    hours_in_advance: setValidationRule('fields.hours_in_advance', {
        required: { error: 'Minimum Hours in Advance is required' },
        minValue: { error: `The minimum number of hours is ${minHoursInAdvance}`, rule: Validators.minValue(minHoursInAdvance) },
    }),
    days_in_future: setValidationRule('fields.days_in_future', {
        required: { error: 'Maximum Days in Future is required' }
    }),
    max_slots: setValidationRule('fields.max_slots', {
        required: { error: 'Maximum Number of Hours is required' },
        minValue: { error: 'Minimum hours is 2', rule: Validators.minValue(2) },
    }),
    street: setValidationRule('fields.street', {
        required: { error: 'Street is required' }
    }),
    state: setValidationRule('fields.state', {
        required: { error: 'State is required' }
    }),
    country: setValidationRule('fields.country', {
        required: { error: 'Country is required' }
    }),
    city: setValidationRule('fields.city', {
        required: { error: 'City is required' }
    }),
    zip: setValidationRule('fields.zip', {
        required: { error: 'Zip is required' },
        valid: { error: 'Invalid Zip code', rule: zipRuleIfNotEmpty },
    }),
    radius: setValidationRule('fields.radius', {
        required: { error: 'Radius is required' }
    }),
    games: {
        $each: {
            name: {
                required: Validators.required,
            },
            description: {
                required: Validators.required,
            },
        },
    },
    openHours: {
        $each: {
            0: {
                required: Validators.required,
            },
            1: {
                required: Validators.required,
            },
        },
    },
    breaks: {
        $each: {
            $each: {
                0: {
                    required: Validators.required,
                },
                1: {
                    required: Validators.required,
                },
            },
        },
    },
}

export default {
    name: 'settings-listing',

    mixins: [
        ComponentMixin,
        FormMixin,
    ],

    data() { return {
         fields: {
            games: [],
            hours_in_advance: 0,
            days_in_future: 0,
            max_slots: 0,
            street: '',
            state: '',
            country: '',
            city: '',
            zip: '',
            radius: '',
            openHours: [],
            breaks: [],
            includeMileageFee: true,
        },

        games: {},
        gameTitles: [],
        weekdays: WEEKDAYS,

        loaded: false,
        submitting: false,
    }},

    computed: {
        countries() {
            return countries.sort((a, b) => ((a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
        },
        minHoursInAdvance() {
            return minHoursInAdvance
        },
    },

    validations() {
        const fields = parseValidations(VALIDATIONS)
        return {
            fields: {
                ...fields,
                games: VALIDATIONS.games,
                openHours: VALIDATIONS.openHours,
                breaks: VALIDATIONS.breaks,
            }
        }
    },

    async created() {
        this.games = Object.fromEntries(window.addiesaas.lairdnd.games.map(game => {
            return [game.name, {
                name: game.name,
                title: game.title,
                addons: [],
            }]
        }))

        this.gameTitles = Object.values(this.games)
            .map(game => ({ value: game.name, text: game.title }))

        for (const upgrade of window.addiesaas.reservations.upgrades) {
            for (const [key, game] of Object.entries(this.games)) {
                if (upgrade.game == key) {
                    game.addons.push({ value: upgrade.name, text: upgrade.title })
                }
            }
        }

        const { data: { data: product } } = await axios.get(`/api/customer/game-master-reservation-product`)

        this.fields.games = product.games
        this.fields.hours_in_advance = product.hours_in_advance
        this.fields.days_in_future = product.days_in_future
        this.fields.max_slots = product.max_slots
        this.fields.street = product.location.street
        this.fields.state = product.location.state
        this.fields.city = product.location.city
        this.fields.zip = product.location.zip
        this.fields.radius = product.location_radius
        this.fields.openHours = product.open_hours
        this.fields.breaks = product.breaks
        this.fields.includeMileageFee = product.include_mileage_fee

        this.fields.country = this.countries.find(country => country.name == product.location.country)?.code

        for (let weekday = 0; weekday < 7; weekday++) {
            if (typeof this.fields.openHours[weekday] === 'undefined') {
                this.fields.openHours[weekday] = ['00:00', '23:59']
            }
            if (typeof this.fields.breaks[weekday] === 'undefined') {
                this.fields.breaks[weekday] = []
            }
        }

        this.validations = parseValidationSetup(VALIDATIONS, this)
        this.setupForm(VALIDATIONS, { hours_in_advance: '', days_in_future: '', max_slots: '', street: '', state: '', country: '', city: '', zip: '', radius: '', games: [], openHours: [], breaks: [] })

        this.loaded = true
    },

    methods: {
        async submit() {
            this.isSuccessPersonal = null

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    const el = get$('.form-group.is-invalid')
                    if (el) {
                        let top = el.offset().top - 86
                        window.scrollTo({ top, behavior: 'smooth' })
                    }
                })
            } else {
                try {
                    this.submitting = true

                    this.formErrorMessage = null

                    const coordinates = await this.getCoordinates()

                    const place = await this.getPlaceByLocation(coordinates)

                    if (coordinates && place) {
                        const payload = {
                            games: this.fields.games,
                            hours_in_advance: this.fields.hours_in_advance,
                            days_in_future: this.fields.days_in_future,
                            max_slots: this.fields.max_slots,
                            location: {
                                street: this.fields.street,
                                state: this.fields.state,
                                country: this.countries.find(country => country.code == this.fields.country).name,
                                city: this.fields.city,
                                zip: this.fields.zip,
                                formatted_address: place.formatted_address,
                                place_id: place.place_id,
                            },
                            location_latitude: coordinates.lat,
                            location_longitude: coordinates.lng,
                            radius: this.fields.radius,
                            open_hours: this.fields.openHours,
                            breaks: this.fields.breaks,
                            include_mileage_fee: this.fields.includeMileageFee
                        }

                        await axios.post(`/api/customer/game-master-reservation-product`, payload)

                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    } else {
                        this.formErrorMessage = 'Cannot detect location of address provided'
                    }
                } catch (e) {
                    this.formErrorMessage = getFirstErrorMessage(e)
                } finally {
                    this.submitting = false
                }
            }
        },

        async getCoordinates() {
            return new Promise((resolve, reject) => {
                const geocoder = new google.maps.Geocoder()

                const address = `${this.fields.street} ${this.fields.city} ${this.fields.state} ${this.fields.country} ${this.fields.zip}`

                const request = { address }

                geocoder.geocode(request, (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        const result = results[0]
                        resolve({
                            lat: result.geometry.location.lat(),
                            lng: result.geometry.location.lng(),
                        })
                    } else {
                        resolve()
                    }
                })
            })
        },

        async getPlaceByLocation(location) {
            return new Promise((resolve, reject) => {
                const geocoder = new google.maps.Geocoder()

                const request = { location }

                geocoder.geocode(request, (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        const place = results.find(result => result.types.includes('premise') || result.types.includes('locality') || result.types.includes('administrative_area_level_3'))
                        resolve(place)
                    } else {
                        resolve()
                    }
                })
            })
        },

        addGame() {
            this.fields.games.push({ name: '', addons: [], description: '' })
        },

        removeGame(gameIndex) {
            this.fields.games.splice(gameIndex, 1)
        },

        addBreak(weekday, breakIndex = 0) {
            this.fields.breaks[weekday].splice(breakIndex, 0, ['', ''])
        },

        removeBreak(weekday, breakIndex) {
            this.fields.breaks[weekday].splice(breakIndex, 1)
        },

        gameAddons(name) {
            if (name && this.games[name]) {
                return this.games[name].addons
            }
            return []
        },
    }
}
</script>
